// extracted by css-extract-rspack-plugin
export default {"bodyText":"_b9f54604"};